import { Instagram as InstagramIcon, Youtube, Mail } from "lucide-react";
import { scrollToId } from "../lib/scroll";
import { EMAIL, INSTAGRAM_URL, YOUTUBE_URL } from "../data/content";

const LINKS = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Portfolio", id: "portfolio" },
  { label: "Contact", id: "inquire" },
];

const SOCIALS = [
  { icon: InstagramIcon, href: INSTAGRAM_URL, label: "Instagram", testid: "footer-instagram-link" },
  { icon: Youtube, href: YOUTUBE_URL, label: "YouTube", testid: "footer-youtube-link" },
  { icon: Mail, href: `mailto:${EMAIL}`, label: "Email", testid: "footer-mail-link" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#150A0E] text-[#F4E9DE] pt-20 pb-28 md:pb-12 border-t border-[#3A242C]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 pb-12 border-b border-[#F4E9DE]/10">
        <div>
          <p className="font-serif-ed text-3xl tracking-[0.3em]">MRINALEE</p>
          <p className="mt-3 text-[11px] uppercase tracking-[0.28em] text-[#D4A960]">Makeup Artist</p>
          <div className="mt-6 flex items-center gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                data-testid={s.testid}
                href={s.href}
                target={s.href.startsWith("http") ? "_blank" : undefined}
                rel="noopener noreferrer"
                aria-label={s.label}
                className="h-10 w-10 rounded-full border border-[#F4E9DE]/15 flex items-center justify-center text-[#F4E9DE]/70 hover:text-[#1C0E13] hover:bg-[#D4A960] hover:border-[#D4A960] transition-colors duration-300"
              >
                <s.icon size={16} />
              </a>
            ))}
          </div>
        </div>
        <nav className="flex flex-wrap gap-x-8 gap-y-3" aria-label="Footer">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`footer-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="text-[11px] uppercase tracking-[0.22em] text-[#F4E9DE]/60 hover:text-[#F4E9DE] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <a
          data-testid="footer-email-link"
          href={`mailto:${EMAIL}`}
          className="text-sm text-[#F4E9DE]/80 hover:text-[#D4A960] transition-colors duration-300"
        >
          {EMAIL}
        </a>
      </div>
      <p className="pt-8 text-center md:text-left text-xs text-[#F4E9DE]/40">
        © 2026 Mrinalee. All rights reserved.
      </p>
    </div>
  </footer>
);
